<template>
  <div 
    v-if="alertStore.alert" 
    class="alert"
    :class="`alert-${alertStore.alert.type}`"
  >
    {{ alertStore.alert.message }}
    <button @click="alertStore.clear()">×</button>
  </div>
</template>

<script setup lang="ts">

import { useAlertStore } from '../stores/alert';
const alertStore = useAlertStore();

</script>
  
  <style scoped>
  .alert {
    justify-self: center;
    padding: 1rem;
    max-width: 350px;
    margin: 1rem 0;
    border-radius: 4px;
    position: relative;
  }
  
  .alert-error {
    background-color: #fee2e2;
    color: #b91c1c;
    border-left: 4px solid #b91c1c;
  }
  
  .alert-success {
    background-color: #dcfce7;
    color: #166534;
    border-left: 4px solid #166534;
  }
  
  .close-btn {
    position: absolute;
    right: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: inherit;
  }
  </style>